import React, { ComponentType, useCallback, useEffect, useRef } from 'react';
import { useWindowSize } from 'shared/hooks/window';
import styles from './content.module.scss';
interface Props {}
export const Content: ComponentType<Props> = (props) => {
  return <div className={styles.host}>{props.children}</div>;
};
